import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { loanManagementUrl } from "../../../../config";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../../theme";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
const base_url = loanManagementUrl.uri;

const ignoreFields = [
  "Loanlimit",
  "Installments",
  "Installmentamount",
  "Applicationdate",
  "Isloanapproved",
  "Interestamount",
  "Isloancleared",
  "Loandisbursedate",
  "Loanapprovaldate",
  "Arrearsoverduedays",
  "Isinarrears",
  "Rolledover",
  "Expectedcleardate",
  "Interestamount",
  "Arrearsoverduedays",
  "Principlearrears",
  "Interestarrears",
  "Isnonperforming",
  "Rolloverpenalty",
  "Iswrittenoff",
  "Loandeclineid",
  "Isloandeclined",
  "Loandeclinedreason",
  "Writtenoffdate",
  "Rolloverdate",
  "Branchcomments",
  "Iscompanyapproved",
  "Isrescheduled",
  "Accountid",
  "Isrebooked",
  "Channelid",
  "Branchid",
  "Regionid",
  "Companyid",
  "Migratedby",
  "Datecreated",
  "Createdby",
  "Updateddate",
  "Updatedby",
  "Verifiedby",
  "Verifieddate",
  "Name",
  "Loancleareddate",
  "Serviceloans",
  "Servicedloans",
  "Loandisbursed",
  "Averagecashsales",
  "Productname",
  "Penaltyapprovalcomments",
  "Penaltyapprovaldate",
  "Penaltyaddedby",
  "Penaltyapprovedby",
  "Penaltyrejectedby",
  "Amounttodisburse",
  "Penaltyrejectioncomments",
];
const columns = [
  { field: "Id", headerName: "CustomerID", flex: 1 },
  { field: "FirstName", headerName: "First Name", flex: 1 },
  { field: "OtherNames", headerName: "Other Names" },
  { field: "MobileNumber", headerName: "Customer Phone" },
  { field: "EmailAddress", headerName: "Email Address" },
  { field: "IdNoOrPassport", headerName: "Id No Or Passport" },
  {
    field: "IsApproved",
    headerName: "Customer Approved",
    flex: 1,
  },
];

const actions = {
  entity: "Register Customer",
  approvePenalty: {
    key: "approveloanpenalty",
    button_name: "Approve",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4, 5],
    modelName: "penaltyApproval", // Specify the model name here
    inputObjectName: "approvePenalty",
    approve: true,
    isgroup: 1,
  },
  rejectPenalty: {
    key: "approveloanpenalty",
    button_name: "Reject",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4, 5],
    modelName: "penaltyApproval", // Specify the model name here
    inputObjectName: "approvePenalty",
    approve: false,
    isgroup: 1,
  },
  dataObject: {
    ignoreFields,
    objectName: "allGroupPenaltyApprovalLoanapplication",
    parameters: "",
  },
  showMore: {
    objectname: "groupPenaltyApprovalViewLoansByColumnValues",
    inputsubobjectname: "application",
    parameters: "id",
    search: true,
    min: 3,
    max: 10,
    otherParams: 1,
    isCustomer: false,
  },
};
function ApproveGroupPenaltyLoan() {
  const [dialogOpen, setDialogOpen] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleOpenModal = () => {
    setDialogOpen(true);
  };

  return (
    <Box m="2px">
      <DynamicTableForJson
        title="Group Loan Penalty Approval"
        subtitle="View all Loans, Approve Penalty"
        // FormComponent={LoanGroupPenaltyApplicationForm}
        // columns={columns}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default ApproveGroupPenaltyLoan;
